@if (isInitialized) {
  <oe-chart [title]="'GENERAL.PRODUCTION' | translate" [period]="service.historyPeriod.value"
    [(showPhases)]="showPhases" [showTotal]="false" (setShowTotal)="setShowTotal($event)">
    <productionTotalChart [isOnlyChart]="true" [showTotal]="showTotal" [showPhases]="showPhases">
    </productionTotalChart>
  </oe-chart>
}
@if (isInitialized) {
  <oe-footer-subnavigation [navigationOptions]="navigationButtons"></oe-footer-subnavigation>
}
